import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
// import { CurrencyUnitSelector } from 'components/BusinessToolForm/components/CurrencyUnitSelector/CurrencyUnitSelector';

import { concatWithDot } from 'helpers/string';

import { InvestmentGridComponent } from './components';
import { INVESTMENT_FORM_NAMES } from './utils/form';
import { investmentFormPrefix } from '../utils/form';

import styles from './InvestmentForm.module.scss';

export const InvestmentForm: FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const tableName = concatWithDot(investmentFormPrefix, INVESTMENT_FORM_NAMES.INVESTMENT_TABLE);
  const forecastedResultName = concatWithDot(investmentFormPrefix, INVESTMENT_FORM_NAMES.INVESTMENT_FORECASTED_RESULT);
  const discountRateName = concatWithDot(investmentFormPrefix, INVESTMENT_FORM_NAMES.DISCOUNT_RATE);

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.FINANCIAL_PERFORMANCE,
  );

  return (
    <>
      <FormSectionCard
        collapsible
        disabled={!canAccess}
        title={t('financialPlan.financialPerformance.investment.description')}
      >
        <Box className={styles['discountRateWrapper']}>
          <NumberInputControlled
            control={control}
            name={discountRateName}
            adornmentType={'percentage'}
            label={t('financialPlan.financialPerformance.investment.discountRate')}
            disabled={!canAccess}
          />
        </Box>
        {/* GROW-2120 turn off this feature until client is agreed */}
        {/* <Box className={styles['currencyWrapper']}>
          <CurrencyUnitSelector disabled={!canAccess} />
        </Box> */}
        <InvestmentGridComponent name={tableName} disabled />
      </FormSectionCard>
      <FormSectionCard
        title={t('financialPlan.financialPerformance.investment.forecastedResult')}
        disabled={!canAccess}
        aiFieldName={forecastedResultName}
      >
        <TextInputControl
          control={control}
          id={forecastedResultName}
          name={forecastedResultName}
          multiline
          minRows={4}
          maxLength={1500}
          disabled={!canAccess}
        />
      </FormSectionCard>
    </>
  );
};
